import { render } from "./addEvents.vue?vue&type=template&id=6baa781a&scoped=true"
import script from "./addEvents.vue?vue&type=script&lang=js"
export * from "./addEvents.vue?vue&type=script&lang=js"

import "./addEvents.vue?vue&type=style&index=0&id=6baa781a&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6baa781a"]])

export default __exports__